import * as React from "react";
import styled from "styled-components";
import { darken } from "@material-ui/core/styles/colorManipulator";
import { TrackedLink, TrackedLinkProps } from "@origin-digital/ods-core";

export interface ButtonActionProps extends Partial<TrackedLinkProps> {
  href: string;
}

export const ButtonActionLink = styled(TrackedLink)<ButtonActionProps>`
  align-items: center;
  background-color: ${p => p.theme.colors.primary};
  border: 0;
  box-shadow: none;
  box-sizing: border-box;
  color: ${p => p.theme.colors.white};
  cursor: pointer;
  display: inline-flex;
  font-family: gordita, Arial, Sans-Serif;
  font-size: 16px;
  font-weight: 600;
  justify-content: center;
  line-height: 24px;
  margin: 0;
  min-width: 64px;
  padding: 12px 24px;
  position: relative;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  text-decoration: none;
  text-transform: none;
  user-select: none;
  vertical-align: middle;
  width: auto;

  & > span {
    font-size: 14px;
    font-weight: 600;
  }

  &:hover {
    background-color: ${p => darken(p.theme.colors.primary, 0.16)};
  }
`;
export const ButtonAction = ({ children, ...others }: ButtonActionProps) => {
  return (
    <ButtonActionLink
      trackingType="Button"
      trackingLabel={children}
      {...others}
    >
      <span>{children}</span>
    </ButtonActionLink>
  );
};
